// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    about_item: 'Over {0}',
    add: 'Toevoegen',
    AddMoreSpace: 'Upgrade nu',
    all_projects_label: 'Alle projecten',
    archive_action_text: 'Archiveren',
    archive_date_label: 'Datum gearchiveerd',
    archived_by_label: 'Gearchiveerd door',
    Attach: 'Bijlage toevoegen',
    attach_file_image: 'Bestand of afbeelding toevoegen',
    automation_purchase_notes: 'Neem contact op met <a href=\'mailto:billing@birdviewpsa.com\'>billing@birdviewpsa.com</a> als je een andere betaalmethode wilt gebruiken dan een bankpas.',
    automation_trial_expired: 'Je proefperiode is verlopen.',
    automation_trial_expired_notes: 'Neem contact op met onze <a href=\'mailto:support@birdviewpsa.com\'>support@birdviewpsa.com</a> voor verdere hulp.',
    btn_reload: 'Vernieuwen',
    buy_subscription: 'Abonnement kopen',
    Cancel: 'Annuleren',
    change: 'Wijzigen',
    checkbox_list_text: 'Meerdere selecteren',
    Close: 'Sluiten',
    completeActivityConfirm: 'Je hebt aangegeven dat deze activiteit 100% is voltooid. Wil je de activiteit voltooien? Druk op \'OK\' om de status te wijzigen, of \'Annuleren\' om dit niet te doen.',
    completeActivityTitle: 'Wil je deze activiteit voltooien?',
    completeProjectConfirm: 'Je hebt aangegeven dat dit project 100% is voltooid. Wil je het project voltooien? Druk op \'OK\' om de status te wijzigen.',
    completeProjectTitle: 'Wil je dit project voltooien?',
    confirmCompleteActivityParents: 'Het voltooien van deze activiteit zal geen onvoltooide activiteiten achterlaten in dit project (ouderactiviteit). Wil je het project of de ouderactiviteit, indien van toepassing, ook voltooien?',
    confirmCompleteActivityParentsTitle: 'Status instellen voor {0} als voltooid?',
    contact_us: 'Contact opnemen',
    continue: 'Doorgaan',
    copy_link_feedback: 'Link gekopieerd.',
    copyLink: 'Kopieer link',
    custom_field_label: 'Aangepast veld',
    date_text: 'Datum',
    DayAbbreviation: 'd',
    DayPluralFormat: '1#dag#dagen',
    DayPluralFormatTemplate: '1#{0} dag#{0} dagen',
    Delete: 'Verwijderen',
    delete_confirmation: 'Deze actie kan niet ongedaan worden gemaakt.',
    delete_permanently_text: 'Definitief verwijderen',
    description_information: 'voor {0}',
    disabled: 'Uitgeschakeld',
    disabledUserText: '(uitgeschakeld)',
    Download: 'Downloaden',
    dropdown_text: 'Uitklaplijst',
    Duplicate: 'Dupliceren',
    Edit: 'Bewerken',
    ElapsedTime_Ago: '{0} geleden',
    enabled: 'Ingeschakeld',
    Entity_Category: 'Categorie',
    Entity_Customer: 'Klant',
    Entity_Issue: 'Probleem',
    Entity_JobRole: 'Functie',
    Entity_OAuthAccountClient: 'OAuth-client',
    Entity_Portfolio: 'Portfolio',
    Entity_Priority: 'Prioriteit',
    Entity_Project: 'Project',
    Entity_ProjectStatus: 'Status',
    Entity_Request: 'Verzoek',
    Entity_Task: 'Taak',
    Entity_TaskStatus: 'Status',
    Entity_User: 'Gebruiker',
    Error_CantFindObjectTemplate: 'De bewerking kon niet worden voltooid om de volgende reden(en): item (type: {entityName}, ID: {objectKey}) niet gevonden in de database. Dit kan te wijten zijn aan het verwijderen van het item of het ontbreken van toestemming om het item te bekijken. Raadpleeg uw {brandName} beheerder voor mogelijke oorzaken.',
    error_notFullyCompleted: 'Een object of gebruiker die betrokken is geweest, is verwijderd of de toegangsrechten zijn ingetrokken door een andere gebruiker.',
    ErrorFileSizeLimit: 'Het uploaden van het bestand {0} kon niet worden voltooid, omdat je geen bestand groter dan ∼ {1} GB kunt uploaden.',
    ErrorUploadExceededText: 'Het uploaden van het bestand {0} kon niet worden voltooid, omdat je account geen ruimte meer heeft.',
    ErrorUploadText: 'Het uploaden van het bestand {0} is mislukt vanwege een onbekende fout. Herhaal het uploadproces alstublieft.',
    ErrorUploadTitle: 'Fout bij het uploaden van bestand.',
    ErrorVirusText: 'Het bestand dat je probeert bij te voegen, kan een virus bevatten. Verwijder het bestand en voer een computerscan uit voor uw veiligheid.',
    ErrorVirusTitle: 'Virus bestand',
    exported: 'Geëxporteerd',
    exporting: 'Exporteren',
    failed: 'Mislukt',
    help: 'Help',
    HourAbbreviation: 'u',
    HourPluralFormat: '1#uur#uren',
    HourPluralFormatTemplate: '1#{0} uur#{0} uren',
    HyperLinkTooltip: 'CTRL+klikken om de link te volgen',
    items_selected_plural: '1#{0} item geselecteerd#{0} items geselecteerd',
    madeBy: 'Aangedreven door',
    MinuteAbbreviation: 'm',
    MinutePluralFormat: '1#{0} min#{0} min',
    more_counter_text: 'en {0} meer',
    next: 'Volgende',
    no_items_selected: 'Geen items geselecteerd',
    None_Text: 'Geen',
    Not_set: 'Niet ingesteld',
    Ok: 'OK',
    open_details_new_tab: 'Details in nieuw tabblad openen',
    open_in_new_tab: 'In nieuw tabblad openen',
    OpeningWindow: 'Openen...',
    OpenOriginal: 'Origineel openen',
    OperationError_Title: 'De bewerking kon niet worden voltooid',
    paragraph_text: 'Paragraaftekst',
    parentActivity: 'ouderactiviteit',
    PerDay: 'per dag',
    PerWeek: 'per week',
    project_custom_fields_label: 'Aangepaste velden project',
    Remove: 'Verwijderen',
    request_has_been_sent_successfully: 'Het verzoek is succesvol verzonden. Success team zal contact met je opnemen.',
    Request_Trial: 'Proefperiode aanvragen',
    Reset: 'Reset',
    Save: 'Opslaan',
    saved: 'Opgeslagen',
    saving: 'Opslaan...',
    Search: 'Zoeken',
    sending: 'Verzenden',
    setCompleted: 'Instellen als voltooid',
    show_less_label: 'Minder weergeven',
    show_more_label: 'Meer weergeven',
    space_exceeded_description: 'Er is niet genoeg beschikbare opslagruimte om bestanden op te slaan.',
    space_exceeded_title: 'Opslagruimte is vol',
    subscribe_trouble_description: 'Neem contact op met <a href=\'mailto:success@birdviewpsa.com\'>success@birdviewpsa.com</a> om je abonnementsstatus te verduidelijken.',
    summary: 'Samenvatting',
    time_input_placeholder: 'Voer de tijd in, bijv. 2u 30m',
    timer_text: '1#{0} seconde#{0} seconden',
    title_notFullyCompleted: 'De bewerking kon niet gedeeltelijk of volledig worden voltooid',
    title_reload: 'Ververs de pagina',
    total: 'Totaal',
    turn_off: 'Uitzetten',
    type: 'Type',
    Type_for_search: 'Typ om te zoeken',
    Type_for_search_or_add: 'Typ om te zoeken of toe te voegen',
    Type_for_search_or_create: 'Typ om te zoeken of aan te maken',
    unarchive_action_text: 'Dearchiveer',
    upload: 'Uploaden',
    WebPushNotificationPanelLink: 'activeer desktopmeldingen.',
    WebPushNotificationPanelText: '{brandName} heeft uw toestemming nodig om ',
    you_user_text: '(jij)',
};
